import { render, staticRenderFns } from "./BaseRegistrationForm.vue?vue&type=template&id=a39b698c&scoped=true&"
import script from "./BaseRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./BaseRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseRegistrationForm.vue?vue&type=style&index=0&id=a39b698c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39b698c",
  null
  
)

export default component.exports